<template>
  <card>
    <div>
      <div class="row">
        <div class="col-5" v-if="$slots.header">
          <slot name="header" />
        </div>
        <div class="col-7" style="padding-top: 5px; line-height: 30px" v-if="$slots.content">
          <slot name="content" />
        </div>
      </div>
      <div v-if="$slots.footer">
        <hr/>
        <slot name="footer" />
      </div>
    </div>

  </card>
</template>
<script>
import Card from "./Card.vue";

export default {
  name: "stats-card",
  components: {
    Card
  }
};
</script>
<style>
</style>
